import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../Components/Button/CustomButton";
import { GetSingleController } from "../../../APIs/Function/Controller/SingleController";
import CustomInput from "../../../Components/input/CustomInput";
import { handleEditSubadmin } from "../../../APIs/Function/Controller/EditSubAdmin";
import * as Yup from "yup";
const EditSubAdmin = () => {
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    privileges: Yup.string().test(
      "min-privileges",
      "At least one privilege must be selected",
      (value) => {
        return value && value.split(",").length >= 1;
      }
    ),
  });
  const navigate = useNavigate();
  const { id } = useParams();
  const [singleSubAdmin, setSingleSubadmin] = useState({});

  const label = { inputProps: { "aria-label": "Color switch demo" } };
  const [formData, setFormData] = useState({
    id: id,
    email: "",
    password: "",
    privileges: [],
  });

  const [loading, setLoading] = useState(false);
  const [loadinga, setLoadinga] = useState(false);
  const [switchValues, setSwitchValues] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
  });

  const handleSwitchChange = (privilege) => {
    const value = privilege.target.checked ? true : false;

    setSwitchValues((prevValues) => ({
      ...prevValues,
      [privilege.target.name]: value,
    }));

    let d = Object.entries(switchValues).map(([key, value]) => {
      if (value) {
        return key;
      }
    });

    d = d.filter(function (element) {
      return element !== undefined;
    });

    setFormData((pre) => {
      return {
        ...pre,
        privileges: d.join(" ,"),
      };
    });
  };

  const handleSinglecontroller = async () => {
    try {
      setLoading(true);
      let res = await GetSingleController(id);
      if (res && res.r && res.r.email) {
        setLoading(false);
        setSingleSubadmin(res.r);
        setFormData({
          ...formData,
          email: res.r.email,
          privileges: res.r.privileges || [], // Update here
        });
      } else {
        setLoading(false);
        console.error(
          "Invalid response or data structure from GetSingleController:",
          res
        );
      }
    } catch (error) {
      console.error("Error fetching single controller:", error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      // Validate the form data against the schema
      await validationSchema.validate(formData, { abortEarly: false });

      setLoadinga(true);
      await handleEditSubadmin({ id, ...formData });
      setLoadinga(false);
      alert("Data Edited Successfully");
      navigate("/controller");
    } catch (error) {
      if (error.name === "ValidationError") {
        // Yup validation error
        const validationErrors = {};
        error.inner.forEach((e) => {
          validationErrors[e.path] = e.message;
        });
        // Show an alert for each validation error
        Object.values(validationErrors).forEach((errorMsg) => {
          alert(` ${errorMsg}`);
        });
      } else {
        // Other errors
        console.error("Error:", error);
      }
    }
  };

  useEffect(() => {
    const g = () => {
      let d = Object.entries(switchValues).map(([key, value]) => {
        if (value) {
          return key;
        }
      });

      d = d.filter(function (element) {
        return element !== undefined;
      });

      setFormData((pre) => {
        return {
          ...pre,
          privileges: d.join(" ,"),
        };
      });
    };

    g();
  }, [switchValues]);

  useEffect(() => {
    if (singleSubAdmin.privileges) {
      const prev = { ...switchValues };

      Object.keys(prev).forEach((privilege) => {
        prev[privilege] = singleSubAdmin.privileges.includes(Number(privilege));
      });

      setSwitchValues(prev);
    }
  }, [singleSubAdmin.privileges]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    handleSinglecontroller();
  }, []);

  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          {" "}
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/controller"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Edit Sub Admin
              </Typography>
            </Box>
            <Box>
              <CustomButton
                onClick={handleSubmit}
                sx={{
                  width: { xs: "40px", md: "50px", lg: "80px" },
                  height: { xs: "10px", md: "50px", lg: "50px " },
                }}
              >
                {loadinga ? <CircularProgress></CircularProgress> : "Save"}
              </CustomButton>{" "}
            </Box>
          </Box>
          <Box>
            <Container maxWidth="sm" sx={{ mt: "30px" }}>
              <form>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CustomInput
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      fullWidth
                      required
                      autoComplete="off"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Paper>
                      <Box sx={{ display: "flex" }}>
                        <Box
                          sx={{
                            border: "1px solid #E8E8E8",
                            width: "50%",
                            p: 2,
                            boxSizing: "border-box",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              User
                            </Typography>{" "}
                            <Switch
                              onChange={handleSwitchChange}
                              name="1"
                              value={switchValues[1]}
                              checked={switchValues[1]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Product
                            </Typography>
                            <Switch
                              onChange={(e) => handleSwitchChange(e)}
                              name="2"
                              {...label}
                              checked={switchValues[2]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Chat
                            </Typography>
                            <Switch
                              onChange={(e) => handleSwitchChange(e)}
                              name="3"
                              {...label}
                              checked={switchValues[3]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Order
                            </Typography>
                            <Switch
                              onChange={(e) => handleSwitchChange(e)}
                              name="4"
                              {...label}
                              checked={switchValues[4]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Coupon
                            </Typography>
                            <Switch
                              onChange={handleSwitchChange}
                              name="5"
                              {...label}
                              checked={switchValues[5]}
                            />
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            border: "1px solid #E8E8E8",
                            width: "50%",
                            p: 2,
                            boxSizing: "border-box",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Workout
                            </Typography>{" "}
                            <Switch
                              onChange={handleSwitchChange}
                              name="6"
                              {...label}
                              checked={switchValues[6]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Home Page Links
                            </Typography>
                            <Switch
                              onChange={handleSwitchChange}
                              name="7"
                              {...label}
                              checked={switchValues[7]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Voucher
                            </Typography>
                            <Switch
                              onChange={handleSwitchChange}
                              name="8"
                              {...label}
                              checked={switchValues[8]}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center ",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "17px",
                                fontFamily: "Open Sans",
                                fontWeight: 400,
                                color: "#737373",
                              }}
                            >
                              Notification
                            </Typography>
                            <Switch
                              onChange={handleSwitchChange}
                              name="9"
                              {...label}
                              checked={switchValues[9]}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </form>
            </Container>
          </Box>
        </Box>
      )}
    </>
  );
};

export default EditSubAdmin;
